import { render, staticRenderFns } from "./login.vue?vue&type=template&id=10d9df09&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=10d9df09&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9df09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d9df09')) {
      api.createRecord('10d9df09', component.options)
    } else {
      api.reload('10d9df09', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=10d9df09&scoped=true", function () {
      api.rerender('10d9df09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login.vue"
export default component.exports